import { PointData, WMSLayerDimension } from "./Map.types";
export const DEFAULT_RADIUS = 6371008.8;
// EPSG:3857 extent of the EFAS (European) domain
export const EFAS_HOME_EXTENT: [number, number, number, number] = [-2782000, 4027000, 5003000, 11575000];

export function epsg3857(point: { lat: number, lon: number }) {
    const lon = point.lon;
    const lat = point.lat;

    const x = (lon * 20037508.34) / 180;
    let y = Math.log(Math.tan(((90 + lat) * Math.PI) / 360)) / (Math.PI / 180);
    y = (y * 20037508.34) / 180;
    return [x, y];
}

export function getCenter(points: PointData[]) {
    let centerLon = 0, centerLat = 0;

    for (const point of points) {
        centerLon += point.location.coordinates[0];
        centerLat += point.location.coordinates[1];
    }

    centerLon /= points.length;
    centerLat /= points.length;

    return [centerLon, centerLat];

}
export function hasDimension(layerDims: undefined | WMSLayerDimension | WMSLayerDimension[], dimension: string): boolean {
    if (!layerDims) {
        return false;
    }
    if (layerDims instanceof Array) {
        return layerDims.some(dim => dim['name'] === dimension);
    } else {
        return layerDims['name'] === dimension;
    }
}

export function keywordValue(keywords: { [key: string]: string }, key: string): string | undefined {
    if (keywords && keywords[key]) {
        return keywords[key];
    }
    return undefined;
}

function getAreaInternal(coordinates: number[][], radius: number) {
    let area = 0;
    const len = coordinates.length;
    let x1 = coordinates[len - 1][0];
    let y1 = coordinates[len - 1][1];
    for (let i = 0; i < len; i++) {
        const x2 = coordinates[i][0];
        const y2 = coordinates[i][1];
        area +=
            radians(x2 - x1) *
            (2 + Math.sin(radians(y1)) + Math.sin(radians(y2)));
        x1 = x2;
        y1 = y2;
    }
    return (area * radius * radius) / 2.0;
}

export function getArea(coordinates: number[][][]) {
    let area = Math.abs(getAreaInternal(coordinates[0], DEFAULT_RADIUS));
    for (let i = 1, ii = coordinates.length; i < ii; ++i) {
        area -= Math.abs(getAreaInternal(coordinates[i], DEFAULT_RADIUS));
    }
    return area;
}

export function radians(degrees: number) {
    return degrees * Math.PI / 180;
};

export function formatArea(area: number) {
    let output;
    if (area > 10000) {
        output = (Math.round((area / 1000000) * 100) / 100).toLocaleString() + ' ' + 'square km';
    } else {
        output = (Math.round(area * 100) / 100).toLocaleString() + ' ' + 'square m';
    }
    return output;
};
